export const ADMIN_PANEL_ROLE_EDIT_PATH = "/roles/:id";
